import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { settingsAPI, resolveImage } from '../utils/api';

export default function OrganizationPaymentDetailsWidget({ containerStyle = {} }) {
  const { t, i18n } = useTranslation();
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await settingsAPI.get();
      if (res.data?.paymentDetails) {
        setPaymentDetails(res.data.paymentDetails);
      }
    } catch (err) {
      console.error('Failed to fetch payment details', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center py-4 text-muted">{t('orgPayment.loading')}</div>;
  }

  if (!paymentDetails || (!paymentDetails.bankName && !paymentDetails.qrCodeUrl)) {
    return (
      <div className="dash-card" style={{ ...containerStyle, padding: '16px', textAlign: 'center', background: '#fff9f9', border: '1px dashed #ccc' }}>
        <div style={{ color: '#888', fontSize: '13px' }}>
          <strong>{t('orgPayment.noDetails')}</strong><br/>
          {t('orgPayment.noDetailsSub')}
        </div>
      </div>
    );
  }

  const { bankName, accountName, accountNumber, fpsId, qrCodeUrl } = paymentDetails;

  return (
    <div className="dash-card" style={{ ...containerStyle }}>
      <div className="dash-card-header">
        <div className="dash-card-title">{t('orgPayment.title')}</div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
        
        {/* Bank Details */}
        {(bankName || accountName || accountNumber || fpsId) && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ fontWeight: '600', color: '#1a1a1a', borderBottom: '1px solid #eaeaea', paddingBottom: '8px' }}>{t('orgPayment.bankTransferInfo')}</div>
            {bankName && (
              <div>
                <div style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase' }}>{t('orgPayment.bankName')}</div>
                <div style={{ fontSize: '13px', fontWeight: '500' }}>{bankName}</div>
              </div>
            )}
            {accountName && (
              <div>
                <div style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase' }}>{t('orgPayment.accountName')}</div>
                <div style={{ fontSize: '13px', fontWeight: '500' }}>{accountName}</div>
              </div>
            )}
            {accountNumber && (
              <div>
                <div style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase' }}>{t('orgPayment.accountNumber')}</div>
                <div style={{ fontSize: '13px', fontWeight: '500' }}>{accountNumber}</div>
              </div>
            )}
            {fpsId && (
              <div>
                <div style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase' }}>{t('orgPayment.fpsId')}</div>
                <div style={{ fontSize: '13px', fontWeight: '500', color: '#0052cc' }}>{fpsId}</div>
              </div>
            )}
            {paymentDetails.bankInstructions && (paymentDetails.bankInstructions.en || paymentDetails.bankInstructions.zh) && (
              <div style={{ marginTop: '8px', padding: '12px', background: '#f5f7fa', borderRadius: '6px', border: '1px solid #e4e7eb' }}>
                <div style={{ fontSize: '11px', color: '#555', textTransform: 'uppercase', marginBottom: '4px', fontWeight: '600' }}>Instructions</div>
                <div style={{ fontSize: '13px', color: '#333', whiteSpace: 'pre-wrap' }}>
                  {paymentDetails.bankInstructions[i18n.language === 'zh' ? 'zh' : 'en'] || paymentDetails.bankInstructions.en || paymentDetails.bankInstructions.zh}
                </div>
              </div>
            )}
          </div>
        )}

        {/* QR Code */}
        {qrCodeUrl && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '8px', borderLeft: (bankName || accountName) ? '1px solid #eaeaea' : 'none', paddingLeft: (bankName || accountName) ? '20px' : '0' }}>
            <div style={{ fontWeight: '600', color: '#1a1a1a', alignSelf: 'flex-start' }}>{t('orgPayment.qrCode')}</div>
            <img 
              src={resolveImage(qrCodeUrl)} 
              alt="Payment QR Code" 
              style={{ width: '280px', height: '280px', objectFit: 'contain', border: '1px solid #eee', borderRadius: '8px', padding: '4px', backgroundColor: '#fff' }}
            />
            <div style={{ fontSize: '11px', color: '#888' }}>{t('orgPayment.scanToPay')}</div>
          </div>
        )}

      </div>
    </div>
  );
}
